<template>
  <div class="c-language-select u-px">
    <div class="c-language-select__label">
      {{ $t('LANGUAGE_SELECT_LABEL') }}:
    </div>
    <VSelect
      v-if="selected"
      :options="langs"
      :value="selected"
      :clearable="false"
      :searchable="false"
      @input="onSelectChange"
    />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import VSelect from 'vue-select'

export default {
  name: 'LanguageSelect',

  components: {
    VSelect
  },

  props: {
    langs: Array
  },

  setup(props, { root }) {
    const selected = computed(() => root.$store.state.appConfig.currentLocale)
    const onSelectChange = ev => {
      root.$store.dispatch('appConfig/setLocale', ev)
    }

    return {
      selected,
      onSelectChange
    }
  }
}
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>